
<template>
  <div class="insight-filter">
    <filter-item title="研究性质:" :filterItem="search" @changeitem="(i) => {changeItem(0, i)}" ></filter-item>
    <filter-item title="适用岗位:" :filterItem="position" @changeitem="(i) => {changeItem(1, i)}" ></filter-item>
    <filter-item title="全旅程触点:" :filterItem="journey" @changeitem="(i) => {changeItem(2, i)}"></filter-item>
    <filter-item title="IPD流程阶段:" :filterItem="IPD" @changeitem="(i) => {changeItem(3, i)}"></filter-item>
  </div>
</template>
<script>

const search = [{id: "yanzheng", name: "验证"}, {id: "tansuo", name: "探索"}]
const position = [{id: "chanpinjingli", name: "产品经理"}, {id: "chanpinsheji", name: "产品设计"}, {id: "yewujiagou", name: "业务架构"}, {id: "UI", name: "UI设计"}, {id: "chanpinyunying", name: "产品运营"}, {id: "shichangtuiguang", name: "市场推广"}, {id: "pinpaiguanli", name: "品牌管理"}, {id: "ssxmgl", name: "实施项目管理"}, {id: "jishuzhichi", name: "技术支持"}, {id: "shishiguwen", name: "实施顾问"}, {id: "jiaofuguanli", name: "交付管理"}]
const journey = [{name: "关注"}, {name: "搜索"}, {name: "咨询"}, {name: "市场活动"}, {name: "体验/试用"}, {name: "环境开通"}, {name: "产品使用"}, {name: "社区自助"}, {name: "反馈/支持"}, {name: "续约"}, {name: "增购"}]
const IPD = [{name: "持续规划"}, {name: "持续开发"}, {name: "持续运维"}, {name: "持续运营"}]

import FilterItem from './Filter-item.vue'
export default {
  data(){
     return {
       search,position,journey, IPD,
       filterData: ['不限', '不限', '不限', '不限']
     };
  },
  components: {FilterItem},
  computed: {
  },
  methods: {
  changeItem: function (index, i) {
    this.filterData[index] = i

    this.$nextTick(() => {
       this.$emit('filterData', this.filterData)
    })   
  }
  }
}
</script>

<style lang="scss">
.insight-filter {
  >div {
    margin: 12px 0;
  }

}
 
</style>